import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Divider, Typography, withStyles } from '@material-ui/core';

import { displayView } from 'constants/UI';
import { getGridView } from 'reducers/UI/gridDisplay';
import Functions from 'containers/Col2/Functions';
import MixedView from 'containers/Col2/GridViews/MixedView';
import ProductGroupsView from 'containers/Col2/GridViews/ProductGroupsView';
import QuickSelectView from 'containers/Col2/GridViews/QuickSelectView';
import SaleOptions from 'containers/Col2/SaleOptions';
import CloseButton from 'components/CustomButtons/CloseButton';
import { closeModalPage } from 'actions/modalPage';
import { modalPages } from 'constants/modalPage';
import { setGridView } from 'actions/UI';

const GridContainer = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    '& > div': {
      justifyContent: 'center',
    },
  },
})(Box);

interface Props {
  title: string;
}

function GridModal({ title }: Props) {
  const gridView = useSelector(getGridView);
  const dispatch = useDispatch();

  function close() {
    dispatch(closeModalPage(modalPages.GridModal));
    dispatch(setGridView('main'));
  }
  function getGridViewToShow() {
    switch (gridView) {
      case displayView.functions:
        return <Functions beforeSelect={close} />;
      case displayView.options:
        return <SaleOptions beforeSelect={close} />;
      case displayView.main:
        return <MixedView />;
      case displayView.productGroups:
        return <ProductGroupsView />;
      case displayView.quickSelect:
      default:
        return <QuickSelectView />;
    }
  }
  return (
    <div>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        padding="1rem"
      >
        <Typography variant="h5">{title}</Typography>
        <CloseButton action={close} />
      </Box>
      <Divider />
      <GridContainer>{getGridViewToShow()}</GridContainer>
    </div>
  );
}

export default GridModal;
